import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import ErrorPage from '@/views/errorPage/ErrorPage.vue'
import MaintenancePage from '@/views/maintenancePage/MaintenancePage.vue'
import RegisterTeamPage from '@/views/registerTeam/RegisterTeamPage.vue'
import AuthenticateUserPage from '@/views/AuthenticateUserPage/AuthenticateUserPage.vue'
import SendMailCompletelyPage from '@/views/registerTeam/SendMailCompletelyPage.vue'
import EnterAccountPage from '@/views/registerTeam/EnterAccountPage.vue'
import AddTeamPage from '@/views/registerTeam/AddTeamPage.vue'
import ConfirmationPage from '@/views/registerTeam/ConfirmationPage.vue'
import CompletePage from '@/views/registerTeam/CompletePage.vue'
import PasswordChangeSendMailPage from '@/views/passwordChange/PasswordChangeSendMailPage.vue'
import PasswordChangeSendMailCompletelyPage from '@/views/passwordChange/PasswordChangeSendMailCompletelyPage.vue'
import PasswordChangePage from '@/views/passwordChange/PasswordChangePage.vue'
import PasswordChangeCompletePage from '@/views/passwordChange/PasswordChangeCompletePage.vue'
import MailAddressChangePage from '@/views/mailAddressChange/MailAddressChangePage.vue'
import MailAddressChangeCompletePage from '@/views/mailAddressChange/MailAddressChangeCompletePage.vue'
import MailAddressRegistrationPage from '@/views/registerTeam/MailAddressRegistrationPage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'RegisterTeam',
    component: RegisterTeamPage,
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: ErrorPage,
  },
  {
    path: '/maintenance',
    name: 'MaintenancePage',
    component: MaintenancePage,
  },
  {
    path: '/authenticate',
    name: 'AuthenticateUserPage',
    component: AuthenticateUserPage,
  },
  {
    path: '/sendcompletely',
    name: 'SendMailCompletelyPage',
    component: SendMailCompletelyPage,
  },
  {
    path: '/regist',
    name: 'RegistPage',
    component: EnterAccountPage,
  },
  {
    path: '/invite',
    name: 'InvitePage',
    component: EnterAccountPage,
  },
  {
    path: '/addTeam',
    name: 'AddTeamPage',
    component: AddTeamPage,
  },
  {
    path: '/confirmation',
    name: 'ConfirmationPage',
    component: ConfirmationPage,
  },
  {
    path: '/inviteConfirmation',
    name: 'InviteConfirmationPage',
    component: ConfirmationPage,
  },
  {
    path: '/complete',
    name: 'CompletePage',
    component: CompletePage,
  },
  {
    path: '/inviteComplete',
    name: 'InviteCompletePage',
    component: CompletePage,
  },
  {
    path: '/password_change_send_mail',
    name: 'PasswordChangeSendMailPage',
    component: PasswordChangeSendMailPage,
  },
  {
    path: '/password_change_send_mail_completely',
    name: 'PasswordChangeSendMailCompletelyPage',
    component: PasswordChangeSendMailCompletelyPage,
  },
  {
    path: '/password_change',
    name: 'PasswordChangePage',
    component: PasswordChangePage,
  },
  {
    path: '/password_change_complete',
    name: 'PasswordChangeCompletePage',
    component: PasswordChangeCompletePage,
  },
  {
    path: '/mail_address_change',
    name: 'MailAddressChangePage',
    component: MailAddressChangePage,
  },
  {
    path: '/mail_address_change_complete',
    name: 'MailAddressChangeCompletePage',
    component: MailAddressChangeCompletePage,
  },
  {
    path: '/mail_address_registration',
    name: 'MailAddressRegistrationPage',
    component: MailAddressRegistrationPage,
  },
]

const router = createRouter({
  history: createWebHashHistory(`${process.env.BASE_URL}index.html`),
  routes,
})

export default router
